<template>
  <v-menu offset-y open-on-hover close-delay="100" nudge-bottom="18">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        icon
        text
        small
        color="#033666"
        class="mx-1"
      >
        <v-icon>apps</v-icon>
      </v-btn>
    </template>
    <v-list max-height="500">
      <v-card
        v-if="services.length === 1"
        class="d-flex flex-wrap px-3"
        width="150"
        flat
      >
        <v-card
          v-for="(service, i) in services"
          :key="i"
          flat
          width="100%"
          color="transparent"
          class="d-flex align-stretch"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              rounded
              class="my-3 mx-2 d-flex align-center"
              :color="hover ? '#e8f0fe' : 'transparent'"
              flat
              @click="GoToService(service)"
            >
              <v-row no-gutters class="text-center">
                <v-col cols="12">
                  <v-card
                    class="d-flex align-center justify-center"
                    flat
                    color="transparent"
                    height="50"
                  >
                    <img width="45%" :src="service.serviceLogo" />
                  </v-card>
                </v-col>
                <v-col cols="12" style="font-size: 13px">{{
                  service.serviceName
                }}</v-col>
              </v-row>
            </v-card>
          </v-hover>
        </v-card>
      </v-card>
      <v-card
        v-if="services.length === 2"
        class="d-flex flex-wrap px-3"
        width="250"
        flat
      >
        <v-card
          v-for="(service, i) in services"
          :key="i"
          flat
          width="50%"
          color="transparent"
          class="d-flex align-stretch"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              rounded
              class="my-3 mx-2 d-flex align-center"
              :color="hover ? '#e8f0fe' : 'transparent'"
              flat
              @click="GoToService(service)"
            >
              <v-row no-gutters class="text-center">
                <v-col cols="12">
                  <v-card
                    class="d-flex align-center justify-center"
                    flat
                    color="transparent"
                    height="50"
                  >
                    <img width="45%" :src="service.serviceLogo" />
                  </v-card>
                </v-col>
                <v-col cols="12" style="font-size: 13px">{{
                  service.serviceName
                }}</v-col>
              </v-row>
            </v-card>
          </v-hover>
        </v-card>
      </v-card>
      <v-card
        v-if="services.length >= 3"
        class="d-flex flex-wrap px-3"
        width="340"
        flat
      >
        <v-card
          v-for="(service, i) in services"
          :key="i"
          flat
          width="33%"
          color="transparent"
          class="d-flex align-stretch"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              rounded
              class="my-3 mx-2 d-flex align-center"
              :color="hover ? '#e8f0fe' : 'transparent'"
              flat
              @click="GoToService(service)"
            >
              <v-row no-gutters class="text-center">
                <v-col cols="12">
                  <v-card
                    class="d-flex align-center justify-center"
                    flat
                    color="transparent"
                    height="50"
                  >
                    <img width="60%" :src="service.serviceLogo" />
                  </v-card>
                </v-col>
                <v-col cols="12" style="font-size: 13px">{{
                  service.serviceName
                }}</v-col>
              </v-row>
            </v-card>
          </v-hover>
        </v-card>
      </v-card>
      <v-card flat class="d-flex justify-center my-4">
        <v-btn color="#033666" outlined @click="ContactChatme"
          ><span style="font-size: 13px">ติดต่อเจ้าหน้าที่</span></v-btn
        >
      </v-card>
    </v-list>
  </v-menu>
</template>

<script>
import axios from "axios";
import jwtDecode from "jwt-decode";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      services: [],
    };
  },
  created() {
    axios
      .get(process.env.VUE_APP_DOMAIN + "/CMUser/manageService/serviceFor9dot")
      .then((resp) => {
        if (
          this.$cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token") &&
          jwtDecode(
            this.$cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token")
          ).chatmeTeam
        ) {
          this.services = resp.data;
        } else {
          this.services = resp.data.filter((team) => !team.chatmeTeam);
        }
      });
  },
  methods: {
    ContactChatme() {
      Swal.fire({
        html: `ติดต่อเจ้าหน้าที่ ChatMe ได้ที่<br>เบอร์โทร: <a style="color: #033666;"
              href='tel:0935781416'
              >093-5781416</a
            >, <a style="color: #033666;"
            href='tel:0655214474'
            >065-5214474</a
          >, <a style="color: #033666;"
            href='tel:0655214459'
            >065-5214459</a
          ><br>Email: <a style="color: #033666;"
              href='mailto:cminfo@chatme.co.th'
              >cminfo@chatme.co.th</a
            >`,
        icon: "info",
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        confirmButtonColor: "#033666",
        confirmButtonText: "ตกลง",
      });
    },
    GoToService(service) {
      let a = document.createElement("a");
      a.target = service.blankpage ? "_blank" : "";
      a.href = service.serviceURLPath;
      a.click();
    },
  },
};
</script>
